import React from 'react'
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image'

import { IPost } from '../interfaces/IPost'
import { timeToRead } from '../utils/timeToRead'
import { Label } from './Label'
import { Heading } from './Heading'
import { LinkButton } from './LinkButton'

interface HighlightedPost {
  post: IPost
  showBlogButton?: boolean
}

export const HighlightedPost = ({ post, showBlogButton = false }: HighlightedPost) => {
  const time = timeToRead(post?.content!)

  return (
    <>
      <div key={post.id} className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="relative">
          <a href={`/blog/${post.slug}`}>
            {post.featuredImage && (
              <GatsbyImage
                className="rounded h-full object-cover overflow-hidden"
                image={post?.featuredImage?.node?.gatsbyImage! || null}
                alt={post?.title!}
              />
            )}

            {!post.featuredImage && (
              <StaticImage
                className="rounded overflow-hidden transition-all hover:scale-105"
                src={'../images/blog-post-default.jpg'}
                alt={post?.title!}
              />
            )}

            <Label className="absolute bottom-4 left-4">{`${time} ${
              (time < 2 && 'minuta') ||
              (time >= 2 && time <= 4 && 'minuty') ||
              (time >= 5 && 'minut')
            } čtení`}</Label>
          </a>
        </div>

        <div className="grid gap-8 content-start items-start justify-items-start">
          <Heading as="h2" className="text-xl lg:text-2xl lg:text-primary">
            <a href={`/blog/${post.slug}`}>{post.title}</a>
          </Heading>

          <div
            className=""
            dangerouslySetInnerHTML={{ __html: post?.excerpt! }}
          />

          <div className="flex gap-4">
            <LinkButton
              className="button button--secondary"
              href={`/blog/${post.slug}`}
            >
              Přečíst článek
            </LinkButton>

            {showBlogButton && (
              <LinkButton className="button button--outline" href={`/blog/`}>
                Všechny články
              </LinkButton>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
